import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { EASE } from "../../../UTILS/ANIMATION/motionVariants";

// Outgoing page lifts and softens; incoming page rises out of a light blur.
// filter is cleared at rest: a lingering filter would make this wrapper the
// containing block for fixed elements and break sticky page navigation.
const variants = {
  initial: { opacity: 0, y: 18, filter: "blur(6px)" },
  animate: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.6, ease: EASE },
    transitionEnd: { filter: "none", transform: "none" },
  },
  exit: {
    opacity: 0,
    y: -12,
    filter: "blur(4px)",
    transition: { duration: 0.28, ease: [0.4, 0, 1, 1] },
  },
};

const reduced = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.2 } },
  exit: { opacity: 0, transition: { duration: 0.15 } },
};

const PageTransition = ({ children }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div variants={reduce ? reduced : variants} initial="initial" animate="animate" exit="exit">
      {children}
    </motion.div>
  );
};

export default PageTransition;
